import React from 'react';
import ArquivamentoPage from './arquivamento.page';

function ArquivamentoContainer () {
  return <ArquivamentoPage />;
}

export default ArquivamentoContainer;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/arquivamento.container.js